import React, { useEffect } from "react";
import { Form, Input, Button, Typography, Row, Col, message, Card, Space } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
// import dayjs from 'dayjs';
import api from "../../API";

function OAAccount() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const defaultInfo = location.state;
  useEffect(() => {
    if(defaultInfo){
        form.setFieldsValue({
            accountName: defaultInfo.accountName,
            accountAddress: defaultInfo.accountAddress,
            accountTaxCode: defaultInfo.accountTaxCode,
            OAId: defaultInfo.OAId,
            // AppId: defaultInfo.AppId,
            // secret_key: defaultInfo.secret_key,
            email: defaultInfo.email,
            PhoneNumber: defaultInfo.PhoneNumber,
            // dataStoreKey: defaultInfo.dataStoreKey,
            // packageId: defaultInfo.packageId,
            // purchasedFrom: defaultInfo.purchasedFrom && dayjs(defaultInfo.purchasedFrom),
            // validTo: defaultInfo.validTo && dayjs(defaultInfo.validTo)
        })
    }
  }, []);

  const handleSubmit = async (values) => {
    try {
        const OAAccountObj = {
            ...values,
            // purchasedFrom: dayjs(values.purchasedFrom).format("YYYY-MM-DD"),
            // validTo: dayjs(values.validTo).format("YYYY-MM-DD"),
            UserId: user.userId,
            isActive: 1
        }
        let response = defaultInfo? 
            await api.update_oaaccount_ById(defaultInfo.id, OAAccountObj):
            await api.create_new_oaaccount(OAAccountObj);
        message.success(response.message);
        navigate('/oaaccounts');
    } catch (error) {
        message.error(error.message)
    }
  };

  return (
    <Card 
        style={{ maxWidth: 800, margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
            <Space align="center">
                <Link to={`/oaaccounts`}>
                    <Button style={{width: 50}} icon={<ArrowLeftOutlined />}></Button>
                </Link>
                <Typography.Title level={5} style={{margin: 0}}>{defaultInfo? "Update": "Create New"}  OA Account</Typography.Title>
            </Space>
        }
    >
        <Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ isActive: 1 }}>
            <Row gutter={16}>
            <Col span={24}>
                <Form.Item label="Account Name" name="accountName" rules={[{ required: true, message: "Account Name cannot be empty" }]}>
                <Input />
                </Form.Item>
            </Col>

            {/* <Col span={24}>
                <Form.Item label="Account Address" name="accountAddress" rules={[{ required: true, message: "Account Address cannot be empty" }]}>
                <Input />
                </Form.Item>
            </Col> */}

            {/* <Col xs={24} sm={12}>
                <Form.Item label="Account Tax Code" name="accountTaxCode" rules={[{ required: true, message: "Account Tax Code cannot be empty" }]}>
                <Input />
                </Form.Item>
            </Col> */}

            <Col span={24}>
                <Form.Item label="OAId" name="OAId" rules={[{ required: true, message: "OAId cannot be empty" }]}>
                <Input />
                </Form.Item>
            </Col>

            {/* <Col xs={24} sm={12}>
                <Form.Item label="AppId" name="AppId" rules={[{ required: true, message: "AppId cannot be empty" }]}>
                <Input />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
                <Form.Item label="Secret Key" name="secret_key" rules={[{ required: true, message: "Secret Key cannot be empty" }]}>
                <Input.Password />
                </Form.Item>
            </Col> */}
{/* 
            <Col xs={24} sm={12}>
                <Form.Item label="Email" name="email" rules={[{ required: true, message: "Email cannot be empty"},{ type: "email", message:'Email is incorrect' }]}>
                <Input />
                </Form.Item>
            </Col> */}

            <Col span={24}>
                <Form.Item label="Phone Number" name="PhoneNumber" rules={[{ required: true, message: "Phone Number cannot be empty" }, {pattern: /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/, message: 'Phone number is incorrect'}]}>
                <Input maxLength={10}/>
                </Form.Item>
            </Col>

            {/* <Col xs={24} sm={12}>
                <Form.Item label="Data Store Key" name="dataStoreKey">
                <Input />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
                <Form.Item label="Package ID" name="packageId" rules={[{required: true, message: "Package ID cannot be empty" }]}>
                <InputNumber min={1} style={{ width: "100%" }}/>
                </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
                <Form.Item label="Purchased From" name="purchasedFrom" rules={[{ required: true, message:"Purchased From cannot be empty" }]}>
                <DatePicker style={{ width: "100%" }} />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
                <Form.Item label="Valid To" name="validTo" rules={[{ required: true, message:"Valid To cannot be empty" }]}>
                <DatePicker style={{ width: "100%" }} />
                </Form.Item>
            </Col> */}
            </Row>

            <Form.Item style={{ textAlign: "center" }}>
                <Button type="primary" htmlType="submit" icon={defaultInfo? <EditOutlined/>: <SaveOutlined/>}>
                    {defaultInfo? "Update": "Save"}
                </Button>
            </Form.Item>
        </Form>
    </Card>
  );
};

export default OAAccount;
